import { useTranslation } from 'react-i18next'

import {
  Flex,
  PrimaryButton,
  SecondaryButton,
  TertiaryButton,
  chakra,
} from '@enechain/ecloud-designsystem'

import { Modal } from '~/components/common/Modal'

type Props = {
  isOpen: boolean
  /** 「保存して移動」処理中はボタンを loading にする。 */
  saving: boolean
  onSaveAndLeave: () => void
  onDiscardAndLeave: () => void
  onCancel: () => void
}

/**
 * 未保存変更がある状態でアプリ内遷移しようとした時の 3 択ダイアログ (AC-011d)。
 *
 * 「保存して移動 / 破棄して移動 / キャンセル」。
 * per-プロセス保存モデルのため「保存して移動」は dirty な全プロセスを順に保存する
 * (= 親 index.tsx が実装)。
 */
export const UnsavedLeaveDialog = ({
  isOpen,
  saving,
  onSaveAndLeave,
  onDiscardAndLeave,
  onCancel,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Modal
      footer={
        /* design の離脱ガード modal footer (キャンセル / 破棄して移動 / 保存して移動)
           はいずれも `.btn`(40px) = md。 */
        <Flex alignItems="center" gap="8px" width="100%">
          <SecondaryButton
            marginRight="auto"
            disabled={saving}
            onClick={onDiscardAndLeave}
            size="md"
          >
            {t('page:adminApprovalFlow.leaveGuard.discardAndLeave')}
          </SecondaryButton>
          <TertiaryButton disabled={saving} onClick={onCancel} size="md">
            {t('page:adminApprovalFlow.leaveGuard.cancel')}
          </TertiaryButton>
          <PrimaryButton loading={saving} onClick={onSaveAndLeave} size="md">
            {t('page:adminApprovalFlow.leaveGuard.saveAndLeave')}
          </PrimaryButton>
        </Flex>
      }
      isOpen={isOpen}
      onClose={onCancel}
      size="sm"
      title={t('page:adminApprovalFlow.leaveGuard.title')}
    >
      <chakra.p margin={0}>
        {t('page:adminApprovalFlow.leaveGuard.body')}
      </chakra.p>
    </Modal>
  )
}
